import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from 'react-router';
import MerchantLayout from '../../layout/MerchantLayout';
import { getMerchantDataPasses, recordMerchantEvent } from '../../services/c2dcrm';
import { DataPass } from '../../types/dataPassport';
import { useAuth } from '../../hooks/useAuth';
import ProposePassCard from '../../components/Cards/ProposePassCard';
import { config } from '../../configs/config';
import { useMessageContext } from '../../components/Context/MessagesContext';
import { EventComponent, EventSlug } from '../../constants/events';
import MerchantDataPassCard from '../../components/Cards/MerchantDataPassCard';

const useStyles = makeStyles({
  container: {
    display: 'grid',
    placeItems: 'center',
  },
  grid: {
    maxWidth: '764px',
  },
  wide: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  banner: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    margin: '16px',
  },
});

type StateType = {
  passes: DataPass[];
  loading: boolean;
};


const MerchantPassportSelection: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const [dataPassports, setDataPassports] = useState<StateType>({ passes: [], loading: false });
  const { token } = useAuth();
  const { messages } = useMessageContext();

  useEffect(() => {
    const fetchData = async () => {
      setDataPassports({ passes: [], loading: true });
      try {
        const response = await getMerchantDataPasses(token);
        if (response) setDataPassports({ passes: response.data, loading: false });
      } catch (error) {
        setDataPassports({ passes: [], loading: false });
      }
    };


    fetchData();
  }, [token]);

  const onDataPassDetailsClick = (dataPass: DataPass) => {
    recordMerchantEvent(token, EventComponent.DATA_PASS, dataPass.id, EventSlug.INFO_VIEW_ENTERED);
    history.push(`/data-pass/${dataPass.id}`);
  }

  if (dataPassports.loading) {
    return (
      <MerchantLayout>
        <Typography className={classes.banner} variant="subtitle1">
          <CircularProgress />
        </Typography>
      </MerchantLayout>
    );
  }



  if (!dataPassports.loading && dataPassports.passes.length === 0) {
    return (
      <MerchantLayout>
        <Typography className={classes.banner} variant="subtitle1">
          Coming Soon, watch this space!
        </Typography>
      </MerchantLayout>
    );
  }

  return (
    <MerchantLayout>
      <div className={classes.container}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          spacing={4}
          className={classes.grid}
        >
          <>
            <Grid item className={classes.wide}>
              <Typography variant="h1" color="primary">
                {messages.TransactPass}
              </Typography>
            </Grid>
            {dataPassports.loading && <CircularProgress />}
            {dataPassports.passes.map((dataPass) => (
              <Grid item key={dataPass.id}>
                <MerchantDataPassCard
                  dataPass={dataPass}
                  activateButtonText="View"
                  onDataPassDetailsClick={onDataPassDetailsClick}
                  onActivateButtonClick={onDataPassDetailsClick}
                  merchant
                />
              </Grid>
            ))}
          </>
        </Grid>
        <ProposePassCard perkLink={config.proposeDataPassLink} />
      </div>

    </MerchantLayout>
  );
};

export default MerchantPassportSelection;
